import * as cx from 'classnames';
import { upperCaseFirst } from 'mk/bazaar/common/filters';
import { photoUrl } from 'mk/photo/photoUrl';
import { PhotoEntity } from 'mk2/schemas';
import * as React from 'react';
import styles from './CoverBreadcrumbs.mscss';

interface OwnProps {
    className?: string;
    photo?: PhotoEntity;
    height?: number;
}

type Props = OwnProps;

const CoverBreadcrumbs: React.FunctionComponent<Props> = ({ className, photo, height, children }) => (
    <div className={cx(styles.CoverBreadcrumbs, className)}>
        {photo &&
            <div
                className={cx(
                    styles.CoverBreadcrumbs__photo,
                        styles['CoverBreadcrumbs__photo--trimY'],
                )}
                style={{
                    backgroundImage: `url('${photoUrl(photo, 's1600x1600')}')`,
                }}
            />
        }
        <div className={styles.CoverBreadcrumbs__breadcrumbs}>
            {React.Children.map(children, (child, index) => (
                <>
                    {index > 0 && (
                        <span className={styles.CoverBreadcrumbs__breadcrumbs__separator}>
                            <i className="fa fa-angle-right" />
                        </span>
                    )}
                    {React.isValidElement<{ className?: string }>(child)
                        ? React.cloneElement(child, { className: cx(child.props.className, styles.CoverBreadcrumbs__breadcrumbs__item)})
                        : (
                            <span className={styles.CoverBreadcrumbs__breadcrumbs__item}>{child}</span>
                        )}
                </>
            ))}
        </div>
    </div>
);

CoverBreadcrumbs.displayName = 'CoverBreadcrumbs';

export default CoverBreadcrumbs;
